/**
 * Created by 11789 on 2017/7/10.
 * @discription
 * @parameter
 * @example
 */
import cookie from './cookie'

export default {
	uuid: function (){
		return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
			return v.toString(16);
		});
	},
	PV: function(){
		var that = this;
		var uuid = null;
		if(cookie.get('uuid')){
			uuid = cookie.get('uuid')
		}else{
			uuid = that.uuid();
			cookie.set('uuid', uuid, {domain: 'qxiu.com'})
		}
		
		this.timeFormat()
		var host = 'https://point-report.qxiu.com/cgi/dataReport/business/common';
		var param = {};
		param._biz = 'pvRecord';
		param.operTime = new Date().format("yyyy-MM-dd hh:mm:ss");
		param.oemId = 201;
		cookie.get('channelid') && (param.channelId = cookie.get('channelid'));
		param.version = '1.0.0';
		param.modelId = '5';
		param.place = '284';
		param.appId  = 101;
		param.pcId = uuid;

		if(cookie.get('loginType')){
			switch (cookie.get('loginType')) {
                case "qq":
                    param.loginType = 1;
                    break;
                case "wechatGZH":
                	param.loginType = 2;
                    break;
                case "weibo":
                	param.loginType = 3;
                    break;
                case "phone":
                	param.loginType = 4;
                    break;
            }
		}
		if(cookie.get('uid')){
			param.userId = cookie.get('uid');
		}else if(cookie.get('tempid')){
			param.userId = cookie.get('tempid');
		}else{
			this.getTempid();
			return;
		}

		var oImg = new Image();
		oImg.src = host + '?' + $.param(param);
	},
	getTempid: function(){
		var that = this;
		that.uid = Math.floor(Math.random() * 1000000000) + 90000000000;  // 9xx xxxx xxxx  以9打头 11位的游客ID;
		$.ajax({
			type:"post",
			url:"https://api-live.qxiu.com/webProxy/cgi/getMCheck",
			async:true,
			data:{
				userId: that.uid
			},
			dataType: 'jsonp',
			success: function(data){
				if(data.result.mcheck){
					that.mcheck = data.result.mcheck;
					cookie.set('tempid', that.uid, {encode: false, domain: 'qxiu.com'});
					cookie.set('tempmcheck', that.mcheck, {encode: false, domain: 'qxiu.com'});
					that.PV();
				}else{
					setTimeout(function(){
						that.getTempid();
					}, 3 * 1000)
				}
			}
		});
	},
	timeFormat : function(){
	    Date.prototype.format = function(fmt) { 
		     var o = { 
		        "M+" : this.getMonth()+1,                 //月份 
		        "d+" : this.getDate(),                    //日 
		        "h+" : this.getHours(),                   //小时 
		        "m+" : this.getMinutes(),                 //分 
		        "s+" : this.getSeconds(),                 //秒 
		        "q+" : Math.floor((this.getMonth()+3)/3), //季度 
		        "S"  : this.getMilliseconds()             //毫秒 
		    }; 
		    if(/(y+)/.test(fmt)) {
		            fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length)); 
		    }
		     for(var k in o) {
		        if(new RegExp("("+ k +")").test(fmt)){
		             fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
		         }
		     }
		    return fmt; 
		} 
	},
	dataReport: function(){
		var that = this;
		var uuid = null;
		if(cookie.get('uuid')){
			uuid = cookie.get('uuid')
		}else{
			uuid = that.uuid();
			cookie.set('uuid', uuid, {domain: 'qxiu.com', expire: 24 * 365})
		}

		var host = 'https://point-report.qxiu.com/cgi/dataReport/business/common';
		var param = {};
		param._biz = 'pvRecord';
		param.operTime = new Date().format("yyyy-MM-dd hh:mm:ss");
		param.oemId = 201;
		param.channelId = cookie.get('channelid');
		param.version = 1.0;
		param.pcId = uuid;
		param.appId  = 101;	//齐齐

		if(cookie.get('loginType')){
			switch (cookie.get('loginType')) {
                case "qq":
                    param.loginType = 1;
                    break;
                case "wechatGZH":
                	param.loginType = 2;
                    break;
                case "weibo":
                	param.loginType = 3;
                    break;
                case "phone":
                	param.loginType = 4;
                    break;
            }
		}
		if(cookie.get('uid')){
			param.userId = cookie.get('uid');
		}else if(cookie.get('tempid')){
			param.userId = cookie.get('tempid');
		}

		$('.dataReport').click(function(e){
			param.modelId = 5;
			param.place = $(this).attr('data-place');
			var oImg = new Image();
			var url = (host + '?' + $.param(param));
			oImg.src = url;
		})
	},
}



// WEBPACK FOOTER //
// ./src/libs/webLog.js